import * as _ from 'lodash';

export const removeRedundancy = (array: any, fieldName?: string): any[] =>
  _.uniqBy(array, (c: any) => (fieldName ? c[fieldName] : c));

/**
 * Compare if two objects are equal or not
 * @returns true if objects are equal
 */
const areObjectsEqual = (o1: Record<string, any>, o2: Record<string, any>) =>
  Object.keys(o1).length === Object.keys(o2).length &&
  Object.keys(o1).every(p => o1[p] === o2[p]);

/**
 * Compare if two arrays are equal or not
 * @returns true if arrays are equal
 */
export const areArraysEqual = (a1: any[], a2: any[]) =>
  a1.length === a2.length && a1.every((o, idx) => areObjectsEqual(o, a2[idx]));
